<div class="tw-w-full tw-px-4 tw-py-9 tw-relative tw-bg-gray-75 tw-rounded-t-6 tw-font-lexend">
  <div class="tw-mb-6 tw-font-lexend">
    <h1 i18n="@@takeSideFacePhoto" class="tw-text-600 tw-font-bold"> Take side face photo </h1>
    <p i18n="@@anotherAngleWillGiveBetterInsight" class="tw-text-300 tw-mt-1 tw-font-normal tw-text-gray-500">Another angle will give your doctor better insight into your skin's condition</p>
  </div>
  <div class="tw-w-full tw-flex tw-gap-4 tw-mb-6">
    <ng-container>
      <!-- Front face image -->
      <div class="tw-w-1/2 tw-flex tw-flex-col tw-items-center">
        <div class="tw-relative tw-w-full tw-border-4 tw-border-white tw-mb-2 tw-rounded-2 tw-shadow-z1">
          @if (frontFaceImage?.image) {
            <img
              class="tw-w-full tw-aspect-[148/210] tw-object-cover tw-rounded-[7px]"
              [src]="frontFaceImage?.image"
              alt="" />
          }
          <div>
            <img src="/assets/images/green_check_white_background.png" class="tw-absolute tw-top-1.5 tw-right-1.5 tw-z-10 tw-w-6 tw-h-6" alt="check_icon"/>
          </div>
        </div>
        <h1 i18n="@@frontPhoto" class="tw-uppercase tw-text-200 tw-text-gray-500 tw-font-body"> FRONT PHOTO </h1>
      </div>

      <!-- Left side image -->
      <div class="tw-w-1/2 tw-flex tw-flex-col tw-items-center">
        <div class="tw-w-full tw-border-4 tw-border-white tw-mb-2 tw-rounded-2 tw-shadow-z1">
          <div (click)="uploadImage()"
            class="tw-w-full tw-aspect-[148/210] tw-flex tw-justify-center tw-items-center tw-bg-[#EAEAEA] tw-rounded-[7px]">
            <img src="/assets/images/side_face_preview.png"
              class="tw-w-full tw-h-full tw-object-cover tw-py-6 tw-px-3 tw-scale-x-[-1]"
              alt="left face">
          </div>
        </div>
        <h1 i18n="@@sidePhoto" class="tw-uppercase tw-text-200 tw-text-gray-500 tw-font-body"> SIDE PHOTO </h1>
      </div>
    </ng-container>
  </div>

  <div class="tw-mb-3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3">
    <span class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-3 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden"
      (click)="uploadImage()"
    i18n="@@takeSidePhoto">Take Side photo</span>
  </div>

  <div class="tw-absolute tw-flex tw-justify-center tw-items-center tw-z-[100] tw-top-3 tw-right-3 close-sheet"
    style="width: 35px; height: 35px"
    (click)="closePopup()">
    <div class="tw-text-gray-500 tw-text-500 tw-font-bold">&#10005;</div>
  </div>
</div>
